import * as React from 'react';
import {
  List,
  Datagrid,
  Filter,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  TextField,
  DateField,
  ReferenceField,
  ReferenceInput,
} from 'react-admin';

const useTxtData = {
  table: {
    id: 'id',
    S_xumu_id: '畜牧',
    yao_name: '药品名称',
    jiliang: '剂量(g)',
    status: '状态',
    AtTime: '用药时间',
  }
};

export const S_xumu_yongyaoList = (props) => (
  <List {...props} filters={<Filters />}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <ReferenceField label={useTxtData.table.S_xumu_id} source="S_xumu_id" reference="Admin/CMSS_xumu">
        <TextField source="name" />
      </ReferenceField>
      <TextField label={useTxtData.table.yao_name} source="yao_name" />
      <TextField label={useTxtData.table.jiliang} source="jiliang" />
      <TextField label={useTxtData.table.status} source="status" />
      <DateField label={useTxtData.table.AtTime} source="AtTime" showTime />
    </Datagrid>
  </List>
);

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu" alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export const S_xumu_yongyaoEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput label={useTxtData.table.yao_name} source="yao_name" />
      <NumberInput label={useTxtData.table.jiliang} source="jiliang" />
      <SelectInput label={useTxtData.table.status} source="status" choices={[
        { id: '已使用', name: '已使用' },
        { id: '未使用', name: '未使用' },
      ]} />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Edit>
);

export const S_xumu_yongyaoCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput label={useTxtData.table.yao_name} source="yao_name" />
      <NumberInput label={useTxtData.table.jiliang} source="jiliang" />
      <SelectInput label={useTxtData.table.status} source="status" choices={[
        { id: '已使用', name: '已使用' },
        { id: '未使用', name: '未使用' },
      ]} />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Create>
);